export const colors = {
	black: '#000',
	white: '#fff',
	blueDark: '#07102d',
	blueLight: '#47a7dd',
	blueNavy: ' #212037',
	orange: '#f27c00',
	yellowDark: '#ffb400',
	gray: '#a4a4a4',
	grayLight: '#f2f2f2',
	smokyWhite: '#fafafa',
	yellowOrangeGradient: `linear-gradient(
      260.27deg,
      #f27c00 10.06%,
      #ffb400 88.32%
      )`,
};
